(ns entities.tax.specs
  (:require
    [cljs.spec.alpha :as s]
    )
  )

(s/def ::accountant (s/nilable string?))
(s/def ::documents-submitted boolean?)
(s/def ::most-recent-return (s/nilable string?)) ;; date
(s/def ::tax-rate (s/nilable number?))

(s/def ::tax (s/nilable (s/keys :req-un [::accountant
                                         ::documents-submitted
                                         ::most-recent-return
                                         ::tax-rate])))
